/**
 * Antifraud frontend API
 * Antifraud frontend API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum DashboardSection {
    INCIDENT_FRAUD = 'INCIDENT_FRAUD',
    INCIDENT_DRUG = 'INCIDENT_DRUG',
    INCIDENT_PYRAMID_SCHEME = 'INCIDENT_PYRAMID_SCHEME',
    INCIDENT_CASINO = 'INCIDENT_CASINO'
}

